import { memo } from 'react'

import { Button, Text } from '@cash-me/react-components'

import { Col, Grid } from 'components/grid'
import { Polygon } from 'components/polygon'

import { homeRenovationConversionContent } from './data'
import * as S from './styles'

type Props = {
  onClick: () => void
}

export const HomeRenovationConversionCta = memo(({ onClick }: Props) => (
  <S.Section aria-labelledby="home-renovation-conversion-title">
    <Grid col={{ phone: 1, tablet: 12 }}>
      <Col col={{ tablet: 12, desktop: 10 }} start={{ desktop: 2 }}>
        <S.Banner>
          <S.PolygonWrapper aria-hidden>
            <Polygon type="TriangleRound" width={33} height={40} draw="fill" color="#FA0890" />
          </S.PolygonWrapper>

          <S.Copy>
            <Text
              id="home-renovation-conversion-title"
              as="h2"
              size="heading3"
              weight="medium"
              color="var(--colors-neutral-text-contrast-default)"
            >
              {homeRenovationConversionContent.title}
            </Text>
            <Text as="p" size="body1" color="var(--colors-neutral-text-contrast-default)">
              {homeRenovationConversionContent.firstParagraph}
            </Text>
            <Text as="p" size="body1" color="var(--colors-neutral-text-contrast-default)">
              <strong>Simule agora</strong> e descubra como o <strong>Crédito com Garantia de Imóvel da CashMe</strong>{' '}
              pode ajudar você a criar o espaço que sempre imaginou.
            </Text>
          </S.Copy>

          <Button
            aria-label="Simular empréstimo para reforma de casa agora"
            size="lg"
            type="button"
            variants="text-only"
            onClick={onClick}
          >
            Simular agora
          </Button>
        </S.Banner>
      </Col>
    </Grid>
  </S.Section>
))

HomeRenovationConversionCta.displayName = 'HomeRenovationConversionCta'
